export default "__VITE_ASSET__DbsysUpx__"